import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import pointsMarkup from '../markup2/events.js';
import toolsMarkup from '../markup/tools.js';

import cropWrap from '../tools/cropWrapper.js';
import scheduleJS from './schedule.js';



const loaderSpinnerId = 'loaderFestEvents-spiner';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);
const body = document.querySelector('body');
const formAdd = body.querySelector('#modal_one_txt_only');
const form = formAdd.querySelector('#modal_one_txt_only-form');
const name = form.querySelector('#modal_one_txt_only-name');
const addName = form.querySelector('#modal_one_txt_only-txt');
const cardTitle = document.querySelector('#modal_one_txt_only-title');
const addNameSubmitButton = form.querySelector('#modal_one_txt_only-submit');

import modalInfo from '../lk-catalogs/modal_one_txt_only.js';
const cardEvent = document.querySelector('#event_card');
// const cardEventPhoto = cardEvent.querySelector('#events_card-photo');

const cardEventName = cardEvent.querySelector('textarea[name=title]');
const cardEventDesc = cardEvent.querySelector('textarea[name=descriptionTXT]');
const cardRemoveEvent = cardEvent.querySelector('button[name=removeEventCard]');

// const cardEventActiveCheckBox = document.querySelector('#events_card_radio_active_now');
// const cardEventType = document.querySelector('#events_card_type');
// const cardEventPriority = document.querySelector('#events_card_priority');

const cardEventAddChange = cardEvent.querySelector('button[name=save]');
// // const cardEventUploadNewImage = document.querySelector('#events_card_image-uploader');
// const cardEventUploadNewImageElem = document.querySelector('#events_card_image-uploader-Elem');

const mainTabPane = document.querySelector('#FestEvents');
const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');




const menuBt =  document.querySelector('#MenuEvents')

const cropWrapNode1 = cardEvent.querySelector('#image-uploader-wrapper');
const cardPhotoSpinner = cardEvent.querySelector('#uploadSpinner');

let returnScheduleBlock = false;
let filmImageToUpload1 = null;
let filmImageToDelete1 = false;

cropWrap.init(cropWrapNode1, false, {
  dataName: 'none',
  // aspectRatio: 1.7,
  onSave: (blob) => {
    filmImageToUpload1 = blob;
    sentPhoto();
  },
  onDelete: () => {
    filmImageToDelete1 = true;
    deletePhoto();
  }
});

function deletePhoto() {
  xhr.request = {
    metod: 'DELETE',
    url: `events/${cardEvent.getAttribute('currentEvent')}/photo/`,
    data: '',
    callbackSuccess: cleanImg
  };
};
const sentPhoto = () => {
  cardPhotoSpinner.style.opacity = 1;
  xhr.request = {
    metod: 'POST',
    url: `events/${cardEvent.getAttribute('currentEvent')}/photo/`,
    // url: `imgSaver`,
    data: filmImageToUpload1,
    callbackSuccess: () => onSaveComplite()
  };
};


const onSaveComplite = () => {
  getevents();
  cardPhotoSpinner.style.opacity = 0;
};

const onSuccessPointsLoad = (loadedPoints) => {
  pointsMarkup.cleanContainer();
  if (loadedPoints.status === 200) {
    console.log(loadedPoints);
    pointsMarkup.drawDataInContainer(loadedPoints.data);
  } else {
    pointsMarkup.drawMarkupInContainer(`<p>${loadedPoints.message}</p>`);
  }
};

mainTabPaneBTReload.addEventListener('click', function () {
  getevents();
});

function reloadDelay() {
  
  setTimeout(function() { getevents(); }, 1000);
}
cardRemoveEvent.addEventListener('click', function () {

  if (confirm('Вы уверены, что хотите удалить данную карточку?\n\nУдаление этой карточки невозиожно, если она указано в расписании или по ней есть хоть одна предварительная запись.')) {
    xhr.request = {
      metod: 'DELETE',
      url: `events/${cardEvent.getAttribute('currentEvent')}`,
      data: '',
      callbackSuccess: onSuccessAddLoad
    };
  }
});
mainTabPaneBTAdd.addEventListener('click', function () {
  // alert('dfdf');
  cardTitle.innerHTML = 'Создание карточки';
  name.innerHTML = 'Добавить рекламный блок:';
  addName.innerHTML = '';
  addName.placeholder = 'Укажите название события';
  addNameSubmitButton.innerHTML = 'Создать';
  modalInfo.start(`events`, reloadDelay, 'POST');
  $(formAdd).modal('show');
});

mainTabPaneBody.addEventListener('click', function (evt) {
  // определить тип на что нажали
  // console.log(evt.target);
  if (evt.target.attributes.eventID) 
    openEditCard(evt.target.attributes.eventID.nodeValue, false);
});

function openEditCard(eventID, boolReturnScheduleBlock){
  returnScheduleBlock = boolReturnScheduleBlock;
  cardEvent.setAttribute('currentEvent',eventID);
    clearCard();
    xhr.request = {
      metod: 'GET',
      url: `events/${cardEvent.getAttribute('currentEvent')}`,
      data: '',
      callbackSuccess: onSuccessCardLoad
    };

}
function clearCard() {
  // cardEventPhoto.src = '';
       // let path = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/jury/${loadedPoints.data.image}.jpg`;
  cropWrap.setImg(cropWrapNode1, 'https://cdn1.iconfinder.com/data/icons/hipster-4/512/hipster-fashion-style-beard-man-glasses-512.png');
  cardEventName.value = '';
  cardEventDesc.value = '';

}
const getevents = () => {
  console.log('getevents');
  pointsMarkup.cleanContainer();
  pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  // cardPhotoSpinner.innerHTML = loaderSpinnerMarkup;
  xhr.request = {
    metod: 'GET',
    url: 'events',
    data: '',
    callbackSuccess: onSuccessPointsLoad
  };
};


function forEach(data, callback) {
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      callback(key, data[key]);
    }
  }
}


const onSuccessCardLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {
    $(formAdd).modal('hide');
    // cardEventAddChange.innerHTML = 'Изменить';

    cardPhotoSpinner.style.opacity = 0;
    if (loadedPoints.data.image && loadedPoints.data.image.length > 2) {
      let path = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/events/${loadedPoints.data.image}.jpg`;
      cropWrap.setImg(cropWrapNode1, path);
    } else  
      cardPhotoSpinner.style.opacity = 1;

    cardEventName.value = loadedPoints.data.name;
    cardEventDesc.value = loadedPoints.data.description;
  
 

    $(cardEvent).modal('show');
    // setTimeout(function() {  
    //   cardEventDesc.style.height = `${cardEventDesc.scrollHeight}px` ;
    //   cardEventName.style.height = `${cardEventName.scrollHeight}px` ;
    // }, 250);
  }
};
cardEventAddChange.addEventListener('click', function () {

  xhr.request = {
    metod: 'PUT',
    url: `events/${cardEvent.getAttribute('currentEvent')}`,
    data: `name=${cardEventName.value}&desc=${cardEventDesc.value}`,
    callbackSuccess: onSuccessAddLoad
  };
});

const onSuccessAddLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
// ;
  if (loadedPoints.status === 200) {
    $(cardEvent).modal('hide');
    if(returnScheduleBlock)
      scheduleJS.continueCreateEventPublic(cardEvent.getAttribute('currentEvent'));
    else
      getevents();
  }
};
function cleanImg() {

  cardPhotoSpinner.style.opacity = 0;
  // cardEventPhoto.src = 'http://festappbuilder.ru/content/festival/1/events/1/events.jpg';
}



export default {

  start() {
    // getevents();
    menuBt.addEventListener('click', getevents);
  },

  redraw: getevents,openEditCard, 


  stop() {
    pointsMarkup.cleanContainer();
    menuBt.removeEventListener('click', getevents);
  }
};
